<section class="page-wrapper">
   <div class="cart-top-section">
      <div class="container">
         <div class="cart-top-detail">
            <div class="red-titel">Checkout</div>
         </div>
      </div>
   </div>
   <div class="checkout-center-section cf">
      <div class="container">
         <div class="checkout-center-detail cf">
            <div class="checkout-center-detail-left">
               <div class="cart-center-detail-top cf">
                  
                  <div class="cart-center-bottom cf">
                     <div class="cart-center-bottom-general">
                      
                        <div class="checkout-center-detail-right-general-admission-detail cf"
                           *ngFor="let cartitem of cartList">
                           <div class="checkout-center-detail-right-general-admission-name">
                              <h3>{{cartitem?.title}}</h3>
                              <p>{{cartitem?.type}}</p>
                           </div>
                           <div class="checkout-center-detail-right-general-admission-price">
                              <img [src]="cartitem?.image" alt="" height="25px">
                             
                           </div>
                           <div class="checkout-center-detail-right-general-admission-price">
                              <p>{{cartitem?.select_size}}</p>
                           </div>
                           <div class="checkout-center-detail-right-away-fans-btn">
                              <p>£{{cartitem?.amount}}.00</p>
                           </div>
                           
                        </div>
                     </div>
                    
                  </div>
               </div>
            </div>
            <div class="checkout-center-detail-right">
               <div class="checkout-center-detail-right-inner">
                  <h2>Bookings Summary</h2>
                  <div class="checkout-center-detail-right-general-admission">
                     <div class="checkout-center-detail-full">
                        <div class="checkout-center-detail-code">
                           <div class="checkout-center-detail-code-voucher">
                              <a (click)="apply_vourcher()" class="apply">Apply voucher</a>
                           </div>
                           <div class="course-final-apply-voucher-box left-box">
                              <input type="text" placeholder="Enter Code" (keydown.enter)="apply_vourcher()"
                                 id="promo_code">
                              <a href="javascript:void(0);" class="correct">
                                 <span class="right">
                                    <img src="assets/images/correct-shop.png">
                                 </span></a>
                              <a (click)="clearcode()" class="wrong">
                                 <span class="right">
                                    <img src="assets/images/cross.svg">
                                 </span></a>
                           </div>
                        </div>
                        <div class="apply_message"></div>
                     </div>
                     <div class="checkout-center-detail-payment">
                        <div class="checkout-center-detail-payment-total">
                           <div class="checkout-payment-total">
                              <div class="checkout-payment-total-text">Total</div>
                              <div class="checkout-payment-total-price">£{{subTotal}}.00</div>
                           </div>
                           <div class="checkout-payment-discount">
                              <div class="checkout-payment-discount-text">Order Discount</div>
                              <div class="checkout-payment-discount-price">£{{discount_amount}}.00</div>
                           </div>
                        </div>
                        <div class="checkout-payment-payable">
                           <div class="checkout-payment-payable-text">Payable Amount</div>
                           <div class="checkout-payment-payable-price">£{{grandTotal}}.00</div>
                        </div>
                        <div class="checkout-center-detail-left checkout-payment">
                           <div class="checkout-center-detail-address hide-form">
                              <!-- <div class="checkout-center-detail-address-titel">
                                 <h2>Add Address</h2>
                              </div> -->
                              <h3><span class="add-titel">Add Address</span></h3>
                              <form class="checkout-center-detail-address-box cf" #addressForm="ngForm"
                                 (ngSubmit)="addAddress(addressForm)">
                                 <http-message types="success" [data]="checkoutSuccess" class="err-msg-block">
                                 </http-message>
                                 <http-message [type]="'error'" [data]="checkoutError" *ngIf="checkoutError"
                                    class="err-msg-block"></http-message>
                                 <div class="checkout-address-box full">
                                    <app-form-field validation="required" name="full_name"
                                       [(ngModel)]="checkoutRequest.full_name" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Full Name"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box half mr">
                                    <app-form-field validation="required" name="flat_house_no"
                                       [(ngModel)]="checkoutRequest.flat_house_no" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Flat House No"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box half">
                                    <app-form-field validation="required" name="landmark"
                                       [(ngModel)]="checkoutRequest.landmark" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Landmark"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box full">
                                    <app-form-field validation="required" name="location"
                                       [(ngModel)]="checkoutRequest.location" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Location"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box full">
                                    <app-form-field validation="required" name="address1"
                                       [(ngModel)]="checkoutRequest.address1" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Address1"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box full">
                                    <app-form-field validation="required" name="address2"
                                       [(ngModel)]="checkoutRequest.address2" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Address2"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box half mr">
                                    <app-form-field validation="required" name="city" [(ngModel)]="checkoutRequest.city"
                                       class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="City" class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box half">
                                    <app-form-field validation="required" name="state"
                                       [(ngModel)]="checkoutRequest.state" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="State" class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box half mr">
                                    <app-form-field validation="required" name="country"
                                       [(ngModel)]="checkoutRequest.country" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Country"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box half">
                                    <app-form-field validation="required" name="pincode"
                                       [(ngModel)]="checkoutRequest.pincode" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Post Code"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box full">
                                    <app-form-field validation="required" name="contact"
                                       [(ngModel)]="checkoutRequest.contact" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Phone" class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="show-your-support-right-content-checkbox">
                                    <label class="container-check">Save this information for next time
                                       <input type="checkbox" checked="checked">
                                       <span class="checkmark"></span>
                                    </label>
                                 </div>
                                 <div class="signup-btn ashton-signup-form-btn">
                                    <button type="submit">Submit</button>
                                 </div>
                              </form>
                           </div>
                           <div class="checkout-center-detail-address-content-box " >
                              <!-- <div class="checkout-center-detail-address-titel">
                                 <h2>Add Address</h2>
                              </div> -->
                              <h3><span class="add-titel">Add Address</span> <span class="add-new"><a
                                       (click)="change_or_add()">Add new</a></span></h3>
                              <div class="checkout-center-detail-add-box">
                                 <http-message [type]="'error'" [data]="addressError" *ngIf="addressError"
                                    class="err-msg-block"></http-message>

                                 <div class="checkout-center-detail-address-content"
                                    *ngFor="let address of addressList" (click)="selectaddress(address?.user_address_id)">
                                    <h3>{{address?.location}}</h3>
                                    <p>{{address?.flat_house_no}} {{address?.address1}} {{address?.address2}}
                                       {{address?.landmark}} {{address?.city}} {{address?.state}} {{address?.pincode}}
                                       {{address?.country}}</p>
                                    <div class="show-your-support-right-content-checkbox add-card-check-box">
                                       <label class="container-check">
                                          <input type="checkbox" id="aid-{{address?.user_address_id}}"
                                             >
                                          <span class="checkmark"></span>
                                       </label>
                                    </div>
                                 </div>
                                 <!--  <div class="checkout-center-detail-address-btn">
                                    <a (click)="change_or_add()">Change Address or Add Address</a>
                                 </div> -->
                              </div>
                           </div>
                        </div>
                        <div class="ashton-hero-top-payment-right checkout-payment">
                           <h3><span class="add-titel">Select Card</span> <span class="add-new"><a
                                    (click)="card_or_add()">Add new</a></span></h3>
                           <div class="ashton-hero-top-payment-add-card-detail">
                              <form #cardForm="ngForm" (ngSubmit)="addCard(cardForm)">
                                 <http-message types="success" [data]="cardSuccess" class="err-msg-block">
                                 </http-message>
                                 <http-message [type]="'error'" [data]="cardError" *ngIf="cardError"
                                    class="err-msg-block"></http-message>
                                 <div class="checkout-address-box full">
                                    <app-form-field validation="required" name="name" [(ngModel)]="cardRequest.name"
                                       class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Card Holder Name"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box full">
                                    <app-form-field validation="required" name="number" [(ngModel)]="cardRequest.number"
                                       class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Card Number"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box half mr">
                                    <app-form-field validation="required" name="exp_month"
                                       [(ngModel)]="cardRequest.exp_month" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Exp Month"
                                          class="input-style">
                                    </app-form-field>

                                 </div>
                                 <div class="checkout-address-box half">
                                    <app-form-field validation="required" name="exp_year"
                                       [(ngModel)]="cardRequest.exp_year" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Exp Year"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box full">
                                    <app-form-field validation="required" name="cvc" [(ngModel)]="cardRequest.cvc"
                                       class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="CVC" class="input-style">
                                    </app-form-field>

                                 </div>
                                 <div class="signup-btn ashton-signup-form-btn">
                                    <button type="submit">Submit</button>
                                 </div>
                              </form>
                           </div>
                           <div class="checkout-center-detail-add-box">
                              <http-message [type]="'error'" [data]="cardloadError" *ngIf="cardloadError"
                                 class="err-msg-block"></http-message>

                              <div class="checkout-center-detail-address-content" *ngFor="let card of cardList" (click)="selectcard(card?.id, card?.customer)">
                                 <h3>{{card?.name}}</h3>
                                 <p>**** **** **** {{card?.last4}}</p>
                                 <div class="show-your-support-right-content-checkbox add-card-check-box">
                                    <label class="container-check">
                                       <input type="checkbox" id="cid-{{card?.id}}"
                                          >
                                       <span class="checkmark"></span>
                                    </label>
                                 </div>
                              </div>

                              <!-- <div class="checkout-center-detail-address-btn">
                                    <a (click)="change_or_add()">Change Address or Add Address</a>
                                 </div> -->
                           </div>
                        </div>
                        <div class="checkout-payment-payable-btn">
                           <a (click)="confirm_pay()">Confirm & Pay</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="want-to-buy-season-tickets-section cf">
            <div class="want-to-buy-season-tickets-left">
               <h3>Want to buy Season Tickets?</h3>
            </div>
            <div class="want-to-buy-season-tickets-right">
               <div class="want-to-buy-season-tickets-right-image">
                  <img src="assets/images/season-tickets.svg">
               </div>
            </div>
         </div>
      </div>
   </div>
</section>